import { supabase } from '../lib/supabase';
import { retryWithBackoff } from '../utils/retryWithBackoff';

export const getCommissions = async (affiliateId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('commissions')?.select('*')?.eq('affiliate_id', affiliateId)?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  });
};

export const getCommissionStats = async (affiliateId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('commissions')?.select('amount, status')?.eq('affiliate_id', affiliateId);

    if (error) throw error;

    const totalEarned = data?.reduce((sum, c) => sum + (c?.amount || 0), 0) || 0;
    const pendingAmount = data?.filter(c => c?.status === 'pending')?.reduce((sum, c) => sum + (c?.amount || 0), 0) || 0;
    const paidAmount = data?.filter(c => c?.status === 'paid')?.reduce((sum, c) => sum + (c?.amount || 0), 0) || 0;

    return {
      totalEarned,
      pendingAmount,
      paidAmount,
      totalCommissions: data?.length || 0
    };
  });
};

export const getReferrals = async (affiliateId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('referrals')?.select('*')?.eq('affiliate_id', affiliateId)?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  });
};

export const createReferral = async (referralData) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('referrals')?.insert([referralData])?.select()?.single();

    if (error) throw error;
    return data;
  });
};

export const createCommission = async (commissionData) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('commissions')?.insert(commissionData)?.select()?.single();

    if (error) throw error;
    return data;
  });
};
function commissionService(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: commissionService is not implemented yet.', args);
  return null;
}

export default commissionService;